import { Container } from "@mui/material";
import { AddMaterial } from "../Roofs/AddMaterial";
import { GuttersTable } from "./GuttersTable";
import { FC, useState } from "react";
import { Material } from "../../../../redux/types/Material";

interface GuttersProps {
  onDone: Function;
  materials?: Material[];
}

export const GutterMaterials: FC<GuttersProps> = ({ onDone, materials }) => {
  const [addMaterial, setAddMaterial] = useState(false);

  const onDisplayAddMaterial = () => {
    setAddMaterial(!addMaterial);
  };

  if (addMaterial) {
    return (
      <Container>
        <AddMaterial
          matType="gutters"
          onCancel={() => setAddMaterial(false)}
          onTapAdd={() => {
            setAddMaterial(false);
            onDone("gutters");
          }}
        />
      </Container>
    );
  } else {
    return (
      <GuttersTable
        materials={Array.isArray(materials) ? materials : []}
        onUploadGutters={() => onDisplayAddMaterial()}
      />
    );
  }
};
